import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import createVacancyAPI from '../../api/create-vacancies';
import { IVacancy } from '../../utils/types/state-types';
import { receiveCreateVacancy, rejectCreateVacancy, requestCreateVacancy } from '../actions/admin-page';

interface ICreateVacancyAction {
  type: string;
  payload: {
    cityDisplayName: string,
    city: string,
    cityOrder: number,
    experienceDisplayName: string,
    experience: string,
    experienceOrder: number,
    employmentTypeDisplayName: string,
    employmentType: string,
    employmentTypeOrder: number,
    scheduleDisplayName: string,
    schedule: string,
    scheduleOrder: number,
    salaryDisplayName: string,
    salary: string,
    salaryOrder: number,
    workFormatDisplayName: string,
    workFormat: string,
    workFormatOrder: number,
    gradeDisplayName: string,
    grade: string,
    gradeOrder: number,
    titleDisplayName: string,
    title: string,
    titleOrder: number,
    responsibilitiesDisplayName: string,
    responsibilities: string,
    responsibilitiesOrder: number,
    descriptionVacancyDisplayName: string,
    descriptionVacancy: string,
    descriptionVacancyOrder: number,
    termsName: string,
    terms: string,
    termsOrder: number,
    requirementsDisplayName: string,
    requirements: string,
    requirementsOrder: number,
    division: string,
    group: string,
    alertText: string,
    alertTextRecommendation: string,
    responsibleUser: string,
    private: false,
    status: string,
  }
}

interface ISearchResponse {
  vacancies: IVacancy[];
  divisions: string[];
}

const createVacancy = function* createVacancy(action: ICreateVacancyAction) {
  try {
    const response: ISearchResponse = yield call(createVacancyAPI, action.payload);
    yield put(receiveCreateVacancy({ payload: response }));
  } catch (error) {
    yield put(rejectCreateVacancy({ error }));
  }
};

export default function* createVacancyWatcher() {
  yield takeLatest(requestCreateVacancy, createVacancy);
}
